import { useHistory } from "react-router-dom";
import { useCreateFromSource } from "@/react/components/shared/Emails/useCreateFromSource";
import { broadcastPaths } from "@/react/helpers/urlHelpers/broadcastPaths";
import { useIsEmailHubStatusEnabled } from "@/react/hooks/useIsEmailHubStatus";

export const useConvertEventToBroadcast = () => {
  const history = useHistory();
  const { mutate: convertFromSource, ...rest } = useCreateFromSource();
  const isEmailHubEnabled = useIsEmailHubStatusEnabled();

  const handleSendAnnouncement = ({
    eventId,
    onSuccess,
  }: {
    eventId: number;
    onSuccess?: () => void;
  }) => {
    if (!isEmailHubEnabled) {
      history.push(broadcastPaths.list());
      onSuccess?.();
      return;
    }

    convertFromSource(
      {
        source_content_id: eventId,
        source_content_type: "Event",
      },
      {
        onSuccess: data => {
          onSuccess?.();
          history.push(broadcastPaths.edit({ broadcastId: data.broadcast.id }));
        },
      },
    );
  };

  return {
    onSendAnnouncement: handleSendAnnouncement,
    ...rest,
  };
};
